import {
    all, take, put, select, takeLatest,
} from 'redux-saga/effects';

import {
    REQUEST_GET_ORGA_SUCCESS,
    getOrga,
} from '../../commons/reduxModules/APIOrgas';

import {
    REQUEST_GET_EVENT_TYPES_SUCCESS,
    getEventTypes,
} from '../../commons/reduxModules/APIEventTypes';

import {
    INIT_CONTACT_SUPPORT_APP,
    getOrgaIdSelector,
    initContactSupportSuccess,
    isInitiatedSelector,
    setOrgaId,
} from '../reduxModules/App';

import {
    getAccessTokenSelector,
    getRefreshTokenSelector,
    getScopeSelector,
    setOrgaId as setAuthenticationOrgaId,
} from '../../commons/reduxModules/Authentication';

import {
    REQUEST_GET_ME_SUCCESS,
    getMe,
} from '../../commons/reduxModules/APIMe';
import Scopes from '../../constants/Scopes';

export function* callAction(action) {
    const initializing = action.type === INIT_CONTACT_SUPPORT_APP;
    const orgaIdFromAction = action.payload.orgaId;
    const [
        orgaIdFromStore,
        isInitiated,
        accessToken,
        refreshToken,
        scope,
    ] = yield all([
        select(getOrgaIdSelector),
        select(isInitiatedSelector),
        select(getAccessTokenSelector),
        select(getRefreshTokenSelector),
        select(getScopeSelector),
    ]);
    const orgaId = orgaIdFromStore || orgaIdFromAction;
    if (!initializing && !isInitiated) return;
    if (initializing) {
        let getOrgaActions = [];
        let getOrgaActionsSuccess = [];
        // No orgaId when external app
        if (orgaId && Scopes.USER !== scope) {
            getOrgaActions = [
                put(setOrgaId(orgaId)),
                put(getOrga({ id: orgaId })),
            ];
            getOrgaActionsSuccess = [
                take(REQUEST_GET_ORGA_SUCCESS),
            ];
        }
        yield all([
            put(getEventTypes()),
            put(initContactSupportSuccess()),
            put(setAuthenticationOrgaId(orgaId)),
            ...getOrgaActions,
        ]);
        yield all([
            take(REQUEST_GET_EVENT_TYPES_SUCCESS),
            ...getOrgaActionsSuccess,
        ]);
    }
    if (accessToken && refreshToken) {
        yield put(getMe());
        yield take(REQUEST_GET_ME_SUCCESS);
    }
}

export function* watch() {
    yield takeLatest(INIT_CONTACT_SUPPORT_APP, callAction);
}
